import $ from 'jquery';

import aceEditor from '../Editors/ace';
import langagesConfiguration from '../languagesConfiguration';
import highlitersConfiguration from '../highlitersConfig';

const Ace = {};

Ace.name = highlitersConfiguration.HIGHLITER_ACE;

Ace.availablelanguages = langagesConfiguration.availablelanguages;

Ace.getValideLanguage = function (language) {
  language = langagesConfiguration.claireConversion[language] || language;
  return langagesConfiguration.availablelanguages.indexOf(language) >= 0 ? language : 'text';
};

Ace.getValideSyntaxer = function (language) {
  language = this.getValideLanguage(language);

  return langagesConfiguration.syntaxMap[language] || language;
};

Ace.colorize = function (string, language) {
  var colorizedPromise = $.Deferred();

  aceEditor.load().done(function () {
    var ace = window.ace,
      highlighter = ace.require('ace/ext/static_highlight');

    // replace insecable space utf8 char with standard space
    string = string.replace(/\xA0/g, ' ');

    // replace html non breaking space with standard space
    string = string.replace(/&nbsp;/g, ' ');

    highlighter.render(
      string,
      'ace/mode/' + Ace.getValideSyntaxer(language),
      aceEditor.theme,
      1,
      false,
      function (highlighted) {
        // <code> blocks cannot contain <div> elements, therefore we replace them with spans to garantee the code is correctly displayed
        const htmlWithoutDivs = highlighted.html
          .replace(/<div/g, '<span')
          .replace(/<\/div>/g, '</span>');
        colorizedPromise.resolve(htmlWithoutDivs, highlighted.css);
      }
    );
  });

  return colorizedPromise;
};

export default Ace;
